import fecha from 'fecha'

export const kindToLocalizedString = (kind) => {
    switch (kind) {
        case 'meetup':
            return 'Meetup';
        case 'conference':
            return 'Konferencja';
        case 'panel':
            return 'Panel dyskusyjny';
        case 'talk':
            return 'Prelekcja';
        case 'hackathon':
            return 'Hackaton';
        case 'workshop':
            return 'Workshop';
        default:
            return 'Inne'
    }
};

export const eventToPeopleHeaderString = (event) => {
    switch (event.kind) {
        case 'talk':
            return event.people.length === 1 ? 'Prelegent' : 'Prelegenci';
        case 'hackathon':
            return event.people.length === 1 ? 'Mentor' : 'Mentorzy';
    }

    return 'Prowadzący'
};

const fullDatetimeFormat = '<b>DD.MM.YYYY</b> (dddd), H:mm';
const hourDatetimeFormat = 'H:mm';

export const timeframeToLocalizedString = (timeframe, parentTimeframe) => {
    if (!timeframe || !timeframe.start) {
        return
    }

    const start = new Date(timeframe.start);
    const end = timeframe.end ? new Date(timeframe.end) : null;
    let startStr;

    if (parentTimeframe !== undefined) {
        const parentStart = new Date(parentTimeframe.start);

        if (start.getDate() === parentStart.getDate()) {
            startStr = fecha.format(start, hourDatetimeFormat);
        } else {
            startStr = fecha.format(start, fullDatetimeFormat);
        }
    } else {
        startStr = fecha.format(start, fullDatetimeFormat);
    }

    if (!end) {
        return startStr
    }

    if (start.getDate() === end.getDate()) {
        return startStr + ' - ' + fecha.format(end, hourDatetimeFormat)
    } else {
        return startStr + ' - ' + fecha.format(end, fullDatetimeFormat)
    }
};


// WEBPACK FOOTER //
// ./src/modules/Events/helpers.js